
import React from 'react';


function InputDynamic({ 
    placeholder = '', 
    controlId = null, 
    className = '',
    value = '',
    type = 'text',
    trackChange = () => {},
    onChange = () => {},
    onFocus = () => {},
    onBlur = () => {}, // Default to a no-op function
    ...rest //Allow for additional attributes to be passed down
 }) {

  return (
    <div>       
      <input 
        className={className} 
        id={controlId} 
        type={type}
        placeholder={placeholder} 
        value={value}
        onFocus={(e) => onFocus(e)}
        onBlur={(e) => onBlur(e)}
        onKeyDown={(e) => trackChange(e)} 
        onChange={(e) => onChange(e)}
        {...rest}

      />        
    </div>
  )
}

export default InputDynamic